import { Component, ElementRef, ViewChild } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { NodeService } from '../../Services/api-nodeservice';
import { Api } from '../../Model/api-model';
import { Router } from '@angular/router';
import {RestApiService} from '../../Services/rest-api-service'
import { ApiListDevPortal, ApiDevPortal } from 'src/app/Model/apilist-model';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-apilist',
  templateUrl: './app.apilist.html'
})
export class APIListComponent{
  selectedApi:ApiDevPortal ;

  divRender: boolean;
  apis:Api[];
  cols: any[];
  publicListApi:ApiListDevPortal;
  publicApi:ApiDevPortal[];
  patientAccessApis: any =[];
  loadAppRequest:boolean=false;
  showTopDiv=false;
  showLink=false;

  aetnaCRDCompanionGuideUrl: string = environment.getAemurl() + '/pdfs/Aetna_CRD_Companion_Guide.pdf';

  aetnaPASCompanionGuideUrl: string = environment.getAemurl() + '/pdfs/Aetna_PAS_Companion_Guide.pdf';


  downloadTestDataFile="sandbox_v2_test_member_logins_and_test_data_v2.1.xlsx";

  downloadTestDataFileV2="sandbox_v2_test_member_logins_and_test_data_v2.1.xlsx";

    constructor(private nodeService: NodeService,private router: Router,public restApi: RestApiService,private sanitizer: DomSanitizer) {

      localStorage.setItem("is_cuurent_nav_aem","n");
     }

    

    ngOnInit() {
      this.loadAppRequest=true;
       this.cols = [
            { field: 'apiName',header: 'API Name'}, 
            { field: 'id', header: 'API ID' },
            { field: 'path', header: 'Path' }];
      // this.loadPublicApis();
      this.loadPublicApis_v1();
      }

tabViewAccess = "NA"; 
showPASCompanionGuide: boolean = false;
showCRDCompanionGuide: boolean = false;

loadPublicApis_v1() {

  this.showPASCompanionGuide = false;
  this.showCRDCompanionGuide = false;

  let A2 = localStorage.getItem("viewAccess");

  this.tabViewAccess = A2;

  let secAccess=localStorage.getItem("viewAccessSec");
  localStorage.setItem("path","sandbox");
  return this.restApi.getPublicApis().subscribe((data: {}) => {
 
    this.publicListApi=data as ApiListDevPortal;
     this.patientAccessApis=this.publicListApi.publicAPIView;

     console.log(this.patientAccessApis);

     var PA2 = [];

    if(A2=='provideraccess'){

      for (const i in this.patientAccessApis) {
          
        if (this.patientAccessApis[i].sourceSystem.includes("apigee") ) {
            //console.log(this.patientAccessApis[i]);
              
          


            PA2.push(this.patientAccessApis[i]);
            
          }
        }

    }else{

      for (const i in this.patientAccessApis) {
          
        if (this.patientAccessApis[i].apiName.includes(A2)||(this.patientAccessApis[i].apiName.includes(secAccess)&&this.patientAccessApis[i].sourceSystem.includes("apic")) || this.patientAccessApis[i].apiName.includes("oauth2/token") || this.patientAccessApis[i].apiName.includes("authorize")) {
            //console.log(this.patientAccessApis[i]);
            
            PA2.push(this.patientAccessApis[i]);
            
          }
        }
    }


        //console.log(PA2);
        this.publicApi = PA2;
        console.log(this.publicApi);

     this.publicApi.sort((a: ApiDevPortal, b: ApiDevPortal) => {
      return a.apiName.localeCompare(b.apiName);
      
         }); 
         
     this.loadAppRequest=false; 

    




  },(error)=>{
    this.loadAppRequest=false;
    // console.log(error);
  })
}


  loadPublicApis() {

    let A1 = localStorage.getItem("viewAccess");
    this.tabViewAccess = A1;

    let secAccess=localStorage.getItem("viewAccessSec");
    localStorage.setItem("path","sandbox");
    console.log(" file checking -- 1"+A1+" : "+secAccess)

    if(A1=='provideraccess' || secAccess=='cdshooks'){
      this.downloadTestDataFile="sandbox_v2_test_member_logins_and_test_data_v2.1.xlsx";
      this.downloadTestDataFileV2="sandbox_v2_test_member_logins_and_test_data_v2.1.xlsx";
      console.log(" file checking --2 "+A1+" : "+secAccess)

    }
    else{
      this.downloadTestDataFile="sandbox_v2_test_member_logins_and_test_data_v2.1.xlsx";

      this.downloadTestDataFileV2="sandbox_v2_test_member_logins_and_test_data_v2.1.xlsx";
    }

    return this.restApi.getPublicApis().subscribe((data: {}) => {
   
      this.publicListApi=data as ApiListDevPortal;
       this.patientAccessApis=this.publicListApi.publicAPIView;

      // console.log(this.patientAccessApis);

       var PA1 = [];

       let tokenAdded=false;
       let authAdded=false;
      for (const i in this.patientAccessApis) {
        
          if (this.patientAccessApis[i].apiName.includes(A1) || this.patientAccessApis[i].apiName.includes(secAccess) || this.patientAccessApis[i].apiName.includes("token") || this.patientAccessApis[i].apiName.includes("authorize")) {
              //console.log(this.patientAccessApis[i]);
          
              if(this.patientAccessApis[i].apiName.includes("token")){
                
                  if(!tokenAdded){
                    PA1.push(this.patientAccessApis[i]);
                  }
                   tokenAdded=true;
              }

              else if(this.patientAccessApis[i].apiName.includes("authorize"))
              {
                  
                if(!authAdded){
                  PA1.push(this.patientAccessApis[i]);
                }
                   authAdded=true;
              }
               
              
              else{
                PA1.push(this.patientAccessApis[i]);
               }


             
            
            
             
              
            }
          }
          //console.log(PA1);
          this.publicApi = PA1;
          console.log(this.publicApi);
      
      this.publicApi.sort((a: ApiDevPortal, b: ApiDevPortal) => {
        return a.apiName.localeCompare(b.apiName);
        
           });
            this.loadAppRequest=false; 

      




    },(error)=>{
      this.loadAppRequest=false;
      // console.log(error);
    })
  }


 viewSwagger(){

    localStorage.setItem("path",this.selectedApi.path);
   
    let A2 = localStorage.getItem("viewAccess");

    if(A2=='provideraccess'){
    
      window.open("/details/swagger/"+this.selectedApi.apiURL, "_blank");
    
    }
  
   else{
    if(this.selectedApi.apiName.includes('patientaccess/ExplanationOfBenefit')){
    
     
          if(this.selectedApi.apiName.includes('id')){
           // window.open("/details/swagger/_v2_patientaccess_ExplanationOfBenefit_sandbox_{id}.yaml", "_blank");
             window.open("/swagger/"+this.selectedApi.id+"/"+localStorage.getItem("path"), "_blank");

          }
          else{


            if(this.selectedApi.apiName.includes('v2')){
            //  window.open("/details/swagger/_v2_patientaccess_ExplanationOfBenefit_sandbox.yaml", "_blank");
  
              window.open("/swagger/"+this.selectedApi.id+"/"+localStorage.getItem("path"), "_blank");

            }
            else{
              window.open("/details/swagger/_v1_patientaccess_ExplanationOfBenefit_sandbox.yaml", "_blank");
  
            }



            

          }
    


    }else{
      window.open("/swagger/"+this.selectedApi.id+"/"+localStorage.getItem("path"), "_blank");
   }

  }
 
    
  }

  @ViewChild('details') myDiv: ElementRef;

  onRowSelect() {

    this.showPASCompanionGuide = false;
    this.showCRDCompanionGuide = false;

    if(this.selectedApi.apiName.includes("coveragerequirementsdiscovery")){
                    
      this.showCRDCompanionGuide = true;
    }
    if(this.selectedApi.apiName.includes("priorauthorizationsupport")){
      this.showPASCompanionGuide = true;
    
    }
   
  //this.showTopDiv=true;
  this.myDiv.nativeElement.focus(); 

  this.showLink=false;
  
   if(this.selectedApi.apiName.indexOf('patientaccess') > -1 ){
     localStorage.setItem("showinfo","true");
   }else{
    localStorage.removeItem("showinfo");
   }

   localStorage.setItem("path",this.selectedApi.path);

   let A2 = localStorage.getItem("viewAccess");
    
  if(A2=='provideraccess'){

   // window.open("/details/swagger/"+this.selectedApi.apiURL, "_blank");

    this.generateDownloadJsonUriForApigee(this.selectedApi.apiURL);
  
  }//end of 1st if
  else{
    this.generateDownloadJsonUri(this.selectedApi.id);

  }
  
  
  }


  ngAfterViewChecked(){
    document.querySelectorAll('table')
    .forEach((input) => {
 //     console.log(input.getAttribute("role"));
       if(input.getAttribute("role")=="grid"){
        input.removeAttribute("role");
       }
     
    });

  }

  downloadJsonHref;
  downloadFileName;
  generateDownloadJsonUri(apiId) {
   
    return this.restApi.mySwaggerJson_Get(apiId).subscribe((data: {}) => {
   

      for(const i in data){
        const key = i;
        const value = data[i];
        

        if(key=="security"){
          //  console.log("key "+key)
            localStorage.setItem("securityIBM",JSON.stringify(value));
           }
           if(key=="basePath"){
            //  console.log("key "+key)
              localStorage.setItem("basePath",JSON.stringify(value));
             }
          
    
    }


//    Object.keys(data).forEach(function(key) {
//      const value = data[key];
    

//     if(key=="x-ibm-endpoints"){
  
//      localStorage.setItem("endpoints",JSON.stringify(value));
//     }
//     if(key=="basePath"){
     
 //       localStorage.setItem("basePath",JSON.stringify(value));
  //     }
    

  //});




     
      var theJSON = JSON.stringify(data);
      var uri = this.sanitizer.bypassSecurityTrustUrl("data:application/json;charset=UTF-8," + encodeURIComponent(theJSON));
      this.downloadJsonHref = uri; 
      this.showLink=true;
      this.downloadFileName=this.selectedApi.apiName+".json";

    },(error)=>{
      this.loadAppRequest=false;
      // console.log(error);
    })

   
   
   
 }

 ngAfterViewInit() {
  window.scroll(0,0);

    
     }


     generateDownloadJsonUriForApigee(apiId){

      let url=window.location.hostname;
    
      if(environment.getAemurl()=='none'){
        this.downloadJsonHref ="https://"+url+"/"+apiId;
      }else{
        let fileName=environment.getAemurl()+'/yaml/'+apiId;
        this.downloadJsonHref =fileName;
  
      }
    
     
  
      this.showLink=true;
      this.downloadFileName=apiId;
    }


  }

